export default __webpack_public_path__ + "img/imagen_portada.5d63d3fd.png";